module.exports = __webpack_public_path__ + "img/navodila_slika_4.80857b26.png";